import { textNumbersSymbolsStringValidator } from "../../utils/validators";
import { getOptionalMinLengthTest } from "./getOptionalMinLengthTest";

const VALIDATOR_ADDRESS_MIN_LENGTH = 4;
const VALIDATOR_ADDRESS_MIN_LENGTH_ERROR = `Address should have at least ${VALIDATOR_ADDRESS_MIN_LENGTH} characters.`;

const REGEX_PO_BOX =
  /\b(?:p\.?\s*o\.?|post\s+office)(\s+)?(?:box|[0-9]*)?\b/gim;
const testNoPOBox = {
  name: "No PO Box",
  message: "PO Boxes are not supported",
  test: (value?: string) => !REGEX_PO_BOX.test(value || "")
};

const testMinLengthIfNotEmpty = getOptionalMinLengthTest(
  VALIDATOR_ADDRESS_MIN_LENGTH,
  VALIDATOR_ADDRESS_MIN_LENGTH_ERROR
);

export const validatorAddress = textNumbersSymbolsStringValidator
  .test(testNoPOBox)
  .test(testMinLengthIfNotEmpty);

export const validatorAddressIncludePOBox =
  textNumbersSymbolsStringValidator.test(testMinLengthIfNotEmpty);
